<template>
  <Dialog
    v-model="currentVisible"
    :title="$t('Add Identity provider')"
    width="400px"
    @before-show="onOpen"
  >
    <Form @submit="submit" ref="identityProviderForm">
      <Row gutter="md">
        <Col col="12">
          <Input
            name="name"
            :label="$t('Name')"
            :max-length="20"
            v-model="formData.name"
            required
          />
        </Col>
        <Col col="12">
          <Input
            name="samlMetadataFilename"
            :label="$t('SAML Metadata')"
            ref="samlMetadata"
            type="file"
            required
            v-model="formData.samlMetadataFilename"
          />
        </Col>
      </Row>
      <div class="text-right q-gutter-sm q-mt-sm">
        <Button :label="$t('Cancel')" color="standard" @click="currentVisible = false" />
        <Button :label="$t('Submit')" type="submit" :disabled="loading" :loading="loading" />
      </div>
    </Form>
  </Dialog>
</template>

<script>
import { mapActions } from 'vuex';
import Button from '@design-system/components/Button.vue';
import Dialog from '@design-system/components/Dialog.vue';
import Form from '@design-system/components/Form.vue';
import Input from '@design-system/components/Input.vue';
import Row from '@design-system/components/Row.vue';
import Col from '@design-system/components/Col.vue';

// i18n messages
const messages = {
  en: {
    'Identity provider': 'Identity provider',
    'Add Identity provider': 'Add Identity provider',
    Name: 'Name',
    'SAML Metadata': 'SAML Metadata',
    Cancel: 'Cancel',
    Submit: 'Submit',
  },
  ja: {
    'Identity provider': 'IdP',
    'Add Identity provider': 'IdPを追加',
    Name: '名前',
    'SAML Metadata': 'SAML メタデータ',
    Cancel: 'キャンセル',
    Submit: '変更する',
  },
};

const defaultFormData = {
  id: '',
  name: '',
  samlMetadataFilename: null,
};

export default {
  name: 'FormModal',
  components: { Button, Form, Input, Dialog, Row, Col },
  i18n: { messages },
  props: {
    identityProviderData: Object,
    value: Boolean,
  },
  data() {
    return {
      formData: { ...defaultFormData },
      loading: false,
    };
  },
  computed: {
    currentVisible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    identityProviderData(value) {
      this.formData = {
        ...this.formData,
        ...(Object.keys(value).length
          ? {
              ...value,
              samlMetadataFilename: null,
            }
          : { ...defaultFormData }),
      };
      if (this.$refs.identityProviderForm) {
        this.$nextTick(() => {
          this.$refs.identityProviderForm.clearValidate();
        });
      }
    },
  },
  created() {
    this.reset();
  },
  methods: {
    ...mapActions('identityProviders', {
      saveIdentityProviders: 'saveIdentityProviders',
    }),
    onOpen() {
      this.reset();
    },
    reset() {
      if (this.$refs.identityProviderForm) {
        this.$refs.identityProviderForm.clearValidate();
      }
    },
    async submit() {
      try {
        // Log
        this.$alpha.logger.addBreadcrumb('Click Activation button.');

        // Start Request
        this.loading = true;
        const formData = new FormData();
        formData.append('name', this.formData.name);
        formData.append('type', 'saml');
        formData.append('saml_metadata', this.$refs.samlMetadata.value);
        await this.saveIdentityProviders({ id: this.formData.id, formData });

        // After Request
        this.currentVisible = false;
        await this.$alpha.notify.success('add', this.$t('Identity provider'));
      } catch (error) {
        await this.$alpha.notify.error('add', this.$t('Identity provider'));
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
